import styled from "@emotion/styled";
import { notSelect } from "../../../../styles/general";

const ChecklistItemComponent = styled.div<{ isActive?: boolean }>`
  display: flex;
  font-weight: bold;
  align-items: center;
  cursor: pointer;

  .icon {
    display: ${(props) => (!props.isActive ? "none" : "auto")};
    position: absolute;
    width: 15px;
    height: 15px;
    margin-left: -30px;
    margin-top: 0px;
  }

  width: 100%;
  height: 30px;
  margin-bottom: 1px;
  padding-left: 37.2px;
  ${notSelect}

  &.h1 {
    font-size: 21px;
  }
  &.h2 {
    font-size: 18px;
  }
  &.h3 {
    font-size: 15px;
  }
  &.p {
    font-size: 15px;
    font-weight: initial;
  }

  &:hover {
    background-color: #fb972e;
    border-radius: 4px;
    color: #fff;
  }
`;

export default function ChecklistItem({
  className,
  onClick,
  isActive,
  children,
}) {
  return (
    <ChecklistItemComponent
      className={className}
      onClick={onClick}
      isActive={isActive}
    >
      {children}
    </ChecklistItemComponent>
  );
}
